/* Author: Vaishnavi
Date: 19/11/2019
Issue Description: Visual Bugs fixes assigned by Harshvardhan Kore & Tarun Bhandari
*/
<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="permission-alert-msg" v-show="!ifTeamleaderPermission">
      You have only view permission.
    </div>
    <div class="noData" v-show="ifTeamleaderPermission">
      <span class="text">Click on ‘Add New’ to add new Location in the following list</span>
      <button class="addnewbtn" v-if="locationList.length>3" @click="goToAddLocationPage()">
        <img src="@/assets/group-5.svg" />
        <b>Add New</b>
      </button>
    </div>
    <div :disabled="!(ifTeamleaderPermission)">
      <div v-if="locationList.length">
        <data-table
          :columns="columnNames"
          :tableData="locationList"
          :checkbox="false"
          :withForm="false"
          @editStart="initEditStart"
          @delete="deleteItem"
          :showhistory="false"
        >
          <template v-slot:rowcontent="slotprops">
            <label v-if="slotprops.value.column.key=='Address'">
              {{slotprops.value.record.address ? slotprops.value.record.address.addressLineOne ? `${slotprops.value.record.address.addressLineOne}`+',' : '' : ''}}
              {{slotprops.value.record.address ? slotprops.value.record.address.addressLineTwo ? `${slotprops.value.record.address.addressLineTwo}`+',' : '' : ''}}
              {{slotprops.value.record.address ? slotprops.value.record.address.city_name ? slotprops.value.record.address.city_name : '' : ''}},
              {{slotprops.value.record.address ? slotprops.value.record.address.state_name ? slotprops.value.record.address.state_name : '' : ''}}
              {{slotprops.value.record.address ? slotprops.value.record.address.pincode ? ('- '+slotprops.value.record.address.pincode) : '' : ''}}
            </label>
            <label
              v-if="slotprops.value.column.key=='name'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</label>
          </template>
        </data-table>
      </div>
    </div>
    <form-add-button
      v-show="showAddBtn && locationList.length<=3"
      main_text="+ Add New"
      sub_text="Location"
      @click="goToAddLocationPage()"
      v-if="ifTeamleaderPermission"
    ></form-add-button>
    <pop-up-message
      v-if="showConfirmDeletePopup"
      :message="'Are you sure you want to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "locations",
  mounted() {
    this.showAdd = true;
    this.locationList = this.locationData;
    this.fetchAllLocations();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/locations", {
      locationData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({ getleid: "onboard/legal_entities/legal_entity_ID" }),
    /** Fetch Organisation ID from store */
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    isLoading() {
      return this.isFetching;
    },
    /** Fetch Legal Entity ID from store */
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    showAddBtn() {
      return !this.isFormActive;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.locationValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.locationValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  activated: function() {
    this.locationList = this.locationData[this.le_id];
    this.fetchAllLocations();
    this.getOrgLeIdList();
  },
  data() {
    return {
      currentObj: {},
      toast: false,
      errmsg: "",
      popupType: "ConfirmDelete",
      showConfirmDeletePopup: false,
      showAdd: true,
      isFormActive: false,
      locationList: [],
      columnNames: [
        {
          label: "Location Name",
          key: "name"
        },
        {
          label: "Address",
          key: "Address"
        }
      ],
      locationValue: false,
      role: ""
    };
  },
  methods: {
    ...mapActions("onboard/locations/", {
      act_fetchAll: "fetchAll",
      act_update: "update",
      act_delete: "delete",
      act_changeEditMode: "changeEditMode",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /** Function to fetch the locations list from server */
    async fetchAllLocations() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        this.locationList = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To save the edited item data on store */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyLocations`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    cancel() {
      this.showAdd = true;
    },
    /** Navigations & Function to store location item data on store */
    async goToAddLocationPage() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addLocation`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    deleteItem(item) {
      this.currentObj = item;
      this.showConfirmDeletePopup = true;
    },

    cancelEvent() {
      this.showConfirmDeletePopup = false;
    },
    /** Function to make the server call to delete the BU type item */
    async deleteEvent() {
      try {
        let res = await this.act_delete([this.currentObj, this.le_id]);
        if (res.data.status) {
          this.fetchAllLocations();
          this.showConfirmDeletePopup = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.locationValue = data.data.user.permissions.location ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style scoped lang="scss">
.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}
.addnewbtn {
  float: right;
  b {
    color: #34c0be;
    margin-left: 8px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
